import { useGetsupergroupsQuery } from '../services/homeApi';

export const useSupergroupViewModel = () => {
  const { data } = useGetsupergroupsQuery();
  const superGroupData = data as any ?? [];
  return {
    superGroupData,
  };
};